// Import createRoot from react-dom/client
import { createRoot } from "react-dom/client"; // Updated import
import App from "./App";
import { AppThemeProvider } from "./components/themes/appThemeProvider";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./functions/msalConfig"; // Update path as needed
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { UserProvider } from "./functions/userContext";

// Create root element using react-dom/client's createRoot
const rootElement = document.getElementById("root");
const root = createRoot(rootElement); // Corrected usage
const msalInstance = new PublicClientApplication(msalConfig);

// Render your app
root.render(
  <AppThemeProvider>
    <MsalProvider instance={msalInstance}>
      <UserProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <App />
        </LocalizationProvider>
      </UserProvider>
    </MsalProvider>
  </AppThemeProvider>
);
